import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faUser } from '@fortawesome/free-solid-svg-icons';

const WelcomeMessageHeader = ({ isDark, nombreCompleto, idUsuario }) => {
    return (
        <div
            className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4 pb-3 border-bottom"
            style={{ borderColor: isDark ? '#233142' : '#e2e8f0' }}
        >
            <div>
                <h5
                    className="fw-bold mb-1 d-flex align-items-center gap-2"
                    style={{ color: isDark ? '#f1f5f9' : '#0f172a' }}
                >
                    <FontAwesomeIcon icon={faRobot} className="text-primary" />
                    <span>Mensaje de Bienvenida</span>
                </h5>
                <p className="text-muted small mb-0" style={{ fontSize: '0.85rem' }}>
                    Personaliza tu saludo de atención que se enviará automáticamente al cliente cuando tomes un ticket.
                </p>
            </div>

            {/* Badge del Asesor Logueado */}
            <div className="d-flex align-items-center gap-2">
                <span
                    className="badge rounded-pill px-3 py-1.5 fw-semibold d-inline-flex align-items-center gap-1.5"
                    style={{
                        fontSize: '0.82rem',
                        backgroundColor: isDark ? 'rgba(37, 99, 235, 0.15)' : '#eff6ff',
                        color: isDark ? '#93c5fd' : '#2563eb',
                        border: `1px solid ${isDark ? 'rgba(37, 99, 235, 0.3)' : '#bfdbfe'}`
                    }}
                >
                    <FontAwesomeIcon icon={faUser} />
                    <span>Asesor: {nombreCompleto || `Usuario #${idUsuario}`}</span>
                </span>
            </div>
        </div>
    );
};

export default WelcomeMessageHeader;
